import { Flame } from "lucide-react";

import {
  AgentApprovalBatchCard,
  type ApprovalRow,
} from "./AgentApprovalBatchCard";

type SkillApproval = {
  contact_id: number;
  contact_label: string;
  approval_id: string;
  subject: string;
  signals: string;
};

export const WarmReawakeningCard = () => (
  <AgentApprovalBatchCard<SkillApproval>
    title="Signaux chauds — prospects qui se réveillent"
    description="Croise activité produit récente + silence côté CRM. Pour chaque réveil détecté, l'IA propose un mail court (visio fondateur) sans révéler le tracking."
    icon={Flame}
    iconClass="text-fabrik-orange"
    ctaLabel="Détecter les signaux chauds"
    emptyLabel="Aucun signal chaud actuellement."
    skillId="detect_warm_reawakening"
    skillInput={{ silence_days: 7, limit: 8 }}
    approveSuccessLabel="Envoyé"
    toRow={(
      a,
    ): Pick<ApprovalRow, "approval_id" | "contact_label" | "subtitle"> => ({
      approval_id: a.approval_id,
      contact_label: a.contact_label,
      subtitle: `${a.subject}${a.signals ? ` · ${a.signals}` : ""}`,
    })}
    extractBody={(payload) => {
      const subject = (payload.subject as string | undefined) ?? "";
      const body = (payload.text_body as string | undefined) ?? "(corps vide)";
      const toList = payload.to as string[] | undefined;
      const recipient = Array.isArray(toList) ? toList.join(", ") : "";
      return {
        body: recipient ? `À : ${recipient}\n\n${body}` : body,
        subtitle: subject || undefined,
      };
    }}
    applyEdits={(payload, subtitle, body) => {
      // Le body affiché inclut le "À :" — on le strippe avant save.
      const cleaned = body.replace(/^À\s*:[^\n]*\n+/, "");
      return { ...payload, subject: subtitle, text_body: cleaned };
    }}
  />
);
